<div class="container flex flex-col md:pt-[12px] mt-[230px] sm:mt-4 mb-4 gap-9">
    <ng-container *ngIf="(ecolodgeDataSource | async);else loadingSkeleton">
        <iho-ecolodge-types [dataSource]=" ecolodgeTypes | async" />
        <ng-container *ngIf="mostVisitedDestinations | async as mostVisitedDestinationsData">
            <iho-slider-bg-text *ngIf="resetSwiper() && mostVisitedDestinationsData" [dataSource]="mostVisitedDestinations | async" />
            </ng-container>
      
        <ng-container *ngIf="rentingResidence | async as residenceData">
            <iho-renting-residences-view   *ngIf="resetSwiper() && residenceData" [dataSource]="rentingResidence | async"
                (emitActiveTab)="emitActiveTab($event)" [tabsTitles]="ecolodgeDataSource | async" class="block" />
        </ng-container>
        <ng-container *ngIf="bigBannerDataSource | async as bigBannerDataSourceData">
            <iho-primary-banner *ngIf="bigBannerDataSourceData" [dataSource]="bigBannerDataSource | async" [showBigBanner]="false"></iho-primary-banner>

        </ng-container>
        <ng-container *ngIf="squaretextDataSource | async as squaretextDataSourceData">
            <iho-slider-squaretext-view *ngIf="resetSwiper() && squaretextDataSource"
                [dataSource]="squaretextDataSource | async"></iho-slider-squaretext-view>
            </ng-container>
        <iho-about-iho-ecolodge />
        <iho-ecolodge-host-banner />
        <iho-states-list [dataSource]="(ecolodgeDataSource | async)?.['AccomodationList']!"></iho-states-list>
        <iho-ecolodge-faq />
        <nav>
            <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2">
                <li class="cursor-pointer">
                    <a href="/">
                        <span class=""> ایران هتل آنلاین </span>
                    </a>
                </li>
                <li class="text-black">
                    <span class=""> اقامتگاه </span>
                </li>
            </ol>
        </nav>
    </ng-container>

    <ng-template #loadingSkeleton>
        <div class="flex flex-col mb-4 gap-6">
            <iho-ecolodge-types-skeleton />
            <iho-slider-bg-text-skeleton />
        </div>
    </ng-template>

    <ng-template #rentingResidenceSkeleton>
        <iho-slider-bg-text-skeleton />
    </ng-template>

</div>